import React, { useState, useEffect } from 'react';
import useOnlineStatus from '../hooks/useOnlineStatus';

export default function OfflineBanner() {
  const isOnline = useOnlineStatus();
  const [showBackOnline, setShowBackOnline] = useState(false);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      setWasOffline(true);
      setShowBackOnline(false);
    } else if (wasOffline && isOnline) {
      setShowBackOnline(true);
      /* Update last-sync timestamp */
      localStorage.setItem('nel_last_sync', String(Date.now()));
      const t = setTimeout(() => setShowBackOnline(false), 3000);
      return () => clearTimeout(t);
    }
  }, [isOnline, wasOffline]);

  if (isOnline && !showBackOnline) return null;

  const bannerStyle = {
    position:       'fixed',
    top:            0,
    left:           0,
    right:          0,
    zIndex:         9999,
    padding:        '10px 20px',
    textAlign:      'center',
    fontSize:       13,
    fontWeight:     600,
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center',
    gap:            8,
    transition:     'background 0.3s',
    background:     showBackOnline ? '#22c55e' : '#f59e0b',
    color:          '#fff',
  };

  return (
    <div style={bannerStyle} role="alert" aria-live="polite">
      {showBackOnline ? (
        <><span>✓</span> Back online — syncing your data…</>
      ) : (
        <><span>⚡</span> You are offline — some features may be limited</>
      )}
    </div>
  );
}
